import React from 'react';
import { Box } from '@mui/material';

const BottomActionBar = ({ children, sx }) => {
    return (
        <Box
            sx={ {
                position: 'sticky',
                bottom: 0,
                mt: 'auto',
                mx: -3,
                mb: -3,
                px: 3,
                py: 2,
                backgroundColor: 'slate.100',
                borderTop: theme => `1px solid ${ theme.palette.divider }`,
                boxShadow: '0 -8px 12px -4px rgb(0 0 0 / 0.05)',
                borderBottomLeftRadius: '16px',
                borderBottomRightRadius: '16px',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: 2,
                zIndex: 10,
                ...sx
            } }
        >
            { children }
        </Box>
    );
};

export default BottomActionBar;